<template>
  <b-field
    :label="label"
    :message="error !== null ? error : message"
    :type="error !== null ? 'is-danger' : ''"
  >
    <b-numberinput
      :value="number"
      :lazy="lazy"
      :expanded="expanded"
      :controls-alignment="controlsAlignment"
      :controls-position="controlsPosition"
      :loading="loading"
      :min="min"
      :max="max"
      @input="input"
    />
  </b-field>
</template>

<script>
export default {
  name: 'OInputNumber',

  props: {
    label: {
      type: String,
      default: undefined,
    },
    number: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: undefined,
    },
    minError: {
      type: String,
      default: null,
    },
    max: {
      type: Number,
      default: undefined,
    },
    maxError: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    controlsAlignment: {
      type: String,
      default: undefined,
    },
    controlsPosition: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      error: null,
    }
  },

  watch: {
    min() {
      this.validate(this.number)
    },

    max() {
      this.validate(this.number)
    },

    number(number) {
      this.validate(number)
    },
  },

  methods: {
    getError(number) {
      if (this.min && number < this.min) {
        return this.minError ? this.minError : `Minimum ${this.min}.`
      }

      if (this.max && number > this.max) {
        return this.maxError ? this.maxError : `Maximum ${this.max}.`
      }

      return null
    },

    validate(number) {
      const error = this.getError(number)
      if (this.error !== error) {
        this.error = error
        this.$emit('error', this.error !== null)
      }
    },

    input(number) {
      this.$emit('update:number', number)
    },
  },
}
</script>
